export default __webpack_public_path__ + "static/media/collections_3.8f4cf41d.jpg";